<div class="flex mt-2 mb-2 px-4 md:px-0 w-full">

  <div
    class="bg-white/50 backdrop-blur-sm rounded-[10.4px] p-4 shadow-sm border border-white
           w-full md:max-w-xl overflow-hidden"
  >
    <div class="flex items-start gap-3">
      <div class="block sm:hidden w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
        <app-ivy-face></app-ivy-face>
      </div>
      <div class="flex-1">
        <p class="text-sm text-gray-900 font-medium leading-relaxed">
          {{ data.message }}
        </p>
      </div>
    </div>
  </div>
</div>
